window.addEventListener("load", () => {
	const trigger = document.querySelectorAll("#fave-accordion_trigger");

	trigger.forEach((element) => {
		element.addEventListener("click", () => {
			element.dataset.expanded =
				element.dataset.expanded === "true" ? "false" : "true";

			if (element.getAttribute("aria-expanded") === "true") {
				element.setAttribute("aria-expanded", "false");
			} else {
				element.setAttribute("aria-expanded", "true");
			}

			element.classList.toggle("is-open");
			element.nextElementSibling.classList.toggle("is-open");
		});
	});
});
